var $df882dc728b9d1ae$exports = {};
$df882dc728b9d1ae$exports = {
    "alert": `Alerta`,
    "dismiss": `Dispensar`
};


export {$df882dc728b9d1ae$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
